import WrapperLoadingPage from '../../../containers/general/WrapperLoadingPage'
import ButtonLink from '../../general/ButtonLink'
import Translation from '../../Translation/cont/Translation'

export const WrapperPageMainWrapper = ({addClassName="", children}) => (
    <WrapperLoadingPage>
        <div className={"wrapper" + (addClassName ? ' ' + addClassName : '')}>
            {children}
        </div>
    </WrapperLoadingPage>
)

export const WrapperPagePanelWrapper =({children, handleScroll = false, addClassName = ''}) => (
    <div className={"main-panel" + (addClassName ? ' ' + addClassName : '')} {...('function' === typeof handleScroll && { onScroll: handleScroll})}>
        {children}
    </div>
)

export const WrapperPageHeaderWrapper = ({children}) => (
    <div className="navbar navbar-default navbar-fixed">
        <div className="container-fluid">
            <div className="navbar-header">
                <div className="navbar-triangle"/>
                    {children}
            </div>
        </div>
    </div>
)

export const WrapperPageTitleWrapper = ({children}) => (
    <div className="title-wrapper">
        {children}
    </div>
)

export const WrapperPageTitle = ({pageTitleTransId, pageTitle, id}) => {
    return (
    <h1 className="navbar-brand title-xlarge">{(pageTitle ? pageTitle : pageTitleTransId ? (<Translation id={pageTitleTransId} />) : '')} <span className='selection-id title-large'>{id && '(ID: ' + id + ')'}</span></h1>
)}

export const WrapperPageCloseButton = ({closePagePath}) => (
    closePagePath && <ButtonLink
        pathname={closePagePath}
        className="icon button-back"
        transId="close_page_button"
    />
)

export const WrapperPageCloseFuncButton = ({onClick}) => (
    <div className="button icon button-back" onClick={() => onClick()}>
        <span className="screen-reader-text"><Translation id="close_page_button">Close</Translation></span>
    </div>
)

export const WrapperPageContentWrapper = ({children}) => (
    <div className="site-content-wrapper">
        {children}
    </div>
)

export const WrapperPageContentBoxWrapper = ({children}) => (
    <div className="program-page program-page-edit-selection site-content">
        <div className="selections-item">
            <div className="selections-item header-accordion-item-open single-section">
                <div className="selections-item-content accordion-item">
                    <div className="full-sections">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    </div>
)
